import type { MetricInfo } from '@az3fr/core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { api } from '@/api/api-client';
import { metricSliceActions } from '@/entities/metrics/model/metric.slice';
import { useAppDispatch } from '@/hooks/store.hook';

// @TODO: get this from the @az3fr/functions package
interface MetricsResponse {
	data: MetricInfo[];
}

function useLoadAllMetricsRawQuery() {
	const dispatch = useAppDispatch();
	const queryResult = useQuery({
		queryKey: ['metrics', 'all', 'raw'],
		queryFn: () => api.get<MetricsResponse>('metrics/all/raw'),
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});

	// Sync to Redux when data successfully loads - only called once at app level
	useEffect(() => {
		if (queryResult.isSuccess && queryResult.data) {
			dispatch(metricSliceActions.setAll(queryResult.data.data));
		}
	}, [queryResult.isSuccess, queryResult.data, dispatch]);

	return queryResult;
}

// Hook for components that need React Query state but don't need Redux sync
function useGetMetricsQuery() {
	return useQuery({
		queryKey: ['metrics', 'all', 'raw'],
		queryFn: () => api.get<MetricsResponse>('metrics/all/raw'),
		select: (data) => data.data,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});
}

export { useLoadAllMetricsRawQuery };
